import React, { FC } from 'react'
import { t } from '@lingui/macro'
import { RouteComponentProps, Redirect } from 'react-router-dom'
import gql from 'graphql-tag'
import { apolloClientPrivate } from '../../graphql/apolloClient'
import { useThrowingQuery } from '../../app/hooks/useThrowingQuery'
import { linkBuilder } from '../../../../shared/linkBuilder'
import Loader from '../../components/common/loader/Loader'
import ErrorMessage from '../../components/common/error/ErrorMessage'

interface IRouteParams {
  workspaceId: string
  enrolmentId: string
}

const enrolmentQuery = gql`
  query enrolment($enrolmentId: PositiveInt!) {
    enrolment(id: $enrolmentId) {
      topic {
        id
      }
    }
  }
`

const DeprecatedTopicPage: FC<RouteComponentProps<IRouteParams>> = ({
  match: { params }
}) => {
  const enrolmentId = params.enrolmentId
  const { data, loading } = useThrowingQuery(enrolmentQuery, {
    variables: { enrolmentId: parseInt(enrolmentId, 10) },
    client: apolloClientPrivate
  })

  if (loading) {
    return <Loader />
  }
  // @ts-expect-error 9/11/2020
  if (!data.enrolment) {
    return (
      <ErrorMessage
        message={t`Sorry, the enrolment ID ${enrolmentId} was not found`}
      />
    )
  }
  // @ts-expect-error 9/11/2020
  return <Redirect to={linkBuilder.topicUrl(data.enrolment.topic.id)} />
}

export default DeprecatedTopicPage
